// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2JzTG","productName":"Table_productName__l9vds"};